module KendoExtension {

    export class DropDownList extends kendo.ui.DropDownList {

        static onError(e: kendo.data.DataSourceErrorEvent) {

            var errorMessage = "";
            for (var lError in e.errors) {
                errorMessage = e.errors[lError].errors[0].toString();
            }

            toastr.error(errorMessage);
        }

    }
} 